import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import type { CopilotDraftGenerationProperties } from 'owa-copilot-draft-generation-shared';

export type ProactiveDraftDiscardSource = 'ComposeDiscard' | 'ReadingPaneDelete' | 'ListDelete';
export type ProactiveDraftRenderLocation = 'ReadingPane' | 'Compose';

function getCommonProperties(generationProperties: CopilotDraftGenerationProperties | undefined) {
    return {
        requestId: generationProperties?.requestId,
        sydneyConversationId: generationProperties?.sydneyConversationId,
        generationCreatedDateTime: generationProperties?.createdDateTime,
    };
}

export function logProactiveDraftRendered(
    mailboxInfo: MailboxInfo,
    generationProperties: CopilotDraftGenerationProperties | undefined,
    location: ProactiveDraftRenderLocation
): void {
    logCoreUsage('ProactiveDraft_Rendered', mailboxInfo, {
        location,
        ...getCommonProperties(generationProperties),
    });
}

export function logProactiveDraftOpenedForEditing(
    mailboxInfo: MailboxInfo,
    generationProperties: CopilotDraftGenerationProperties | undefined
): void {
    logCoreUsage('ProactiveDraft_OpenedForEditing', mailboxInfo, {
        ...getCommonProperties(generationProperties),
    });
}

export function logProactiveDraftDiscarded(
    mailboxInfo: MailboxInfo,
    generationProperties: CopilotDraftGenerationProperties | undefined,
    source: ProactiveDraftDiscardSource
): void {
    logCoreUsage('ProactiveDraft_Discarded', mailboxInfo, {
        source,
        ...getCommonProperties(generationProperties),
    });
}
